import React, { useState } from "react";
import { IResourceComponentsProps } from "@pankod/refine-core";
import { List, Row, Col, Card, Typography } from "@pankod/refine-antd";

import { AmcCollectionAccountsTable } from "./components/amc-collection-accounts.table";
import { BulkImportHiddenVendorsModal } from "./components/bulk-import-hidden-vendors.modal";
import { UpdateVendorVisibilityModal } from "./components/update-vendor-visibility.modal";

const { Paragraph, Text } = Typography;

export const AmcListedVendorsList: React.FC<IResourceComponentsProps> = () => {
  // Bumped after a visibility change so the accounts table reloads.
  const [refetchKey, setRefetchKey] = useState(0);

  return (
    <List title={"AMC Listed Vendors"} pageHeaderProps={{ extra: <></> }}>
      <Row gutter={[16, 16]}>
        <Col lg={24} xs={24}>
          <Card title="Bulk import AMC collection accounts">
            <Paragraph>
              Import the AMC collection accounts as <Text strong>hidden</Text> listed vendors.
              Upload a CSV or paste rows, review the parsed preview, then submit. The backend
              creates new accounts, skips ones that already exist, and reports any failures per row.
            </Paragraph>
            <BulkImportHiddenVendorsModal />
          </Card>
        </Col>

        <Col lg={24} xs={24}>
          <Card
            title="AMC collection accounts"
            extra={<UpdateVendorVisibilityModal onUpdated={() => setRefetchKey((key) => key + 1)} />}
          >
            <Paragraph type="secondary">
              Every imported AMC collection account. These must always be hidden from users; hide any
              account marked visible using its vendor id. AMC accounts cannot be unhidden. Turn on
              "Virtual account" for virtual accounts such as MFU escrow: those are never paid via IMPS.
            </Paragraph>
            <AmcCollectionAccountsTable refetchKey={refetchKey} />
          </Card>
        </Col>
      </Row>
    </List>
  );
};
